import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthLoadingScreen from '../components/AuthLoadingScreen/AuthLoadingScreen';
import SessionRenewModal from '../components/SessionRenewModal/SessionRenewModal';
import { useAuth } from '../state/AuthContext';
import { getProtectedRouteRedirect } from './routingContract';

export default function ProtectedRoute({ children }) {
  const { loading, session, renewPrompt, refresh, logout } = useAuth();
  const location = useLocation();

  if (loading) return <AuthLoadingScreen />;

  if (!session) {
    const redirect = getProtectedRouteRedirect(location.pathname);
    return <Navigate to={redirect.pathname} replace state={redirect.state} />;
  }

  return (
    <>
      {children}
      {renewPrompt ? (
        <SessionRenewModal
          onContinue={refresh}
          onLogout={logout}
        />
      ) : null}
    </>
  );
}
